var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingMessage'):_c('vca-card',[_c('h2',[_vm._v(_vm._s(_vm.$t("events.view.header", { 0: _vm.event.name })))]),_c('vca-card',{staticClass:"shadowed"},[_c('vca-column',[_c('EventApplication',{attrs:{"event":_vm.event,"showApplication":true}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }